import YTCookiesDeclined from "^/assets/images/YTCookiesDeclined.png";

/**
 * Generic component to show a cookies declined message for any service
 * @param {Object} props
 * @param {string} props.icon - Icon class (e.g., "lab la-youtube")
 * @param {string} props.serviceKey - The service key for cookie consent (e.g., "youtube")
 * @param {Function} props.onAccept - Callback when user accepts
 * @param {boolean} props.teaser - Whether to show teaser version
 * @param {string} props.lang - Language code ("de" or "en")
 * @param {string} props.serviceType - Type of service for messaging ("video" or "map")
 */
function CookiesDeclinedBanner({
  icon,
  onAccept,
  teaser,
  lang,
  serviceType = "video",
}) {
  const messages = {
    video: {
      de: "Das Video wird Ihnen nicht angezeigt, da Sie nicht der Verwendung von Cookies zugestimmt haben.",
      en: "The video is not displayed because you have not consented to the use of cookies.",
    },
    map: {
      de: "Die Karte wird Ihnen nicht angezeigt, da Sie nicht der Verwendung von Cookies zugestimmt haben.",
      en: "The map is not displayed because you have not consented to the use of cookies.",
    },
  };

  const buttonLabels = {
    de: "Zustimmen",
    en: "Accept",
  };

  let banner = (
    <div className="cookies-declined-container">
      <img
        className="cookies-declined-image"
        src={YTCookiesDeclined}
        width="1200"
        height="800"
      />
      <div className="cookies-declined-elements">
        <div className="cookies-declined-icon cookies-icon">
          <i className={icon} />
        </div>

        <div className="cookies-declined-text">
          <p className="cookies-declined-text-p">
            {messages[serviceType][lang]}
          </p>
        </div>
        <div className="cookies-declined-button">
          <button className="btn bg-theme" onClick={onAccept}>
            {buttonLabels[lang]}
          </button>
        </div>
      </div>
    </div>
  );

  if (teaser) {
    banner = (
      <div className="cookies-declined-container">
        <img className="cookies-declined-image" src={YTCookiesDeclined} />
        <div className="cookies-declined-elements-teaser">
          <div className="cookies-declined-icon-teaser">
            <i className={icon} />
          </div>
        </div>
      </div>
    );
  }

  return <div>{banner}</div>;
}

export default CookiesDeclinedBanner;
